import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../api/client";

// GET /api/v1/hour-packages/ → paquetes de horas de la academia (owner).
function usePackages() {
  return useQuery({
    queryKey: ["hour-packages"],
    queryFn: () => apiClient.get("/api/v1/hour-packages/").then((r) => r.data),
  });
}

export { usePackages };
